export default __webpack_public_path__ + "img/premium-redeemed-a091d6137e78fd0d957d58b5000c4231.png";